import { useEffect, type ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  // E2E bypass: skip auth in Playwright tests
  if (import.meta.env.VITE_E2E === 'true') return <>{children}</>;
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      void loginWithRedirect({ appState: { returnTo: window.location.pathname } });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);
  if (isLoading) return <div role="status">Loading…</div>;
  if (!isAuthenticated) return <div role="status">Redirecting to login…</div>;
  return <>{children}</>;
}
